export default {
  areas: [
    {
      id: "compression",
      icon: "ri-stack-line",
      color: "bg-accent-500",
      title: "Compression Molded Rubber Products",
      subtitle: "Compression Molding",
      desc: "Based on 50 years of compression molding expertise, we precisely manufacture rubber products in the various shapes and materials our customers require. We support flexible production from small to large volumes, realizing even complex shapes in high quality.",
      features: [
        "24 presses from 50 to 500 tons",
        "Product weight from 1g to 5kg",
        "Small batch (single prototype) to mass production (1M units/month)",
        "All materials including EPDM, NBR, CR, SBR, FKM, and silicone",
      ],
      applications: ["Automotive bushings/mounts", "Industrial seals/packing", "Construction anti-vibration pads", "Shipbuilding gaskets"],
      image: "https://storage.readdy-site.link/project_files/e8666665-2242-48cf-9593-4ebcd3ad786e/6b7d0760-d612-4a01-a535-b3c05aa1b7f8_compressed_-.webp",
    },
    {
      id: "industrial",
      icon: "ri-settings-3-line",
      color: "bg-primary-500",
      title: "Industrial Rubber Parts",
      subtitle: "Industrial Rubber Parts",
      desc: "We manufacture high-performance rubber parts that withstand extreme environments in heavy industry, chemical plants, shipbuilding, and construction equipment. Products are designed by selecting rubber compounds optimized for heat, chemical, abrasion, and weather resistance in each industrial environment.",
      features: [
        "Material design for high temperature, pressure, and chemical environments",
        "Specialized in heat exchanger gaskets, flange packing, and diaphragms",
        "Large products (up to 2m) available",
        "Compliance with KS, ASTM, JIS and other standards",
      ],
      applications: ["Chemical plant seals/gaskets", "Power plant packing", "Shipbuilding fenders", "Construction equipment parts"],
      image: "https://readdy.ai/api/search-image?query=Various%20black%20industrial%20rubber%20parts%20and%20seals%20arranged%20neatly%20on%20clean%20workshop%20table%2C%20gaskets%20O-rings%20diaphragms%20of%20different%20sizes%2C%20professional%20industrial%20components%20photography%2C%20soft%20diffused%20lighting%2C%20precision%20engineering%20aesthetic%2C%20clean%20organized%20manufacturing%20environment&width=1200&height=800&seq=krubber-business-industrial&orientation=landscape",
    },
    {
      id: "automotive",
      icon: "ri-car-line",
      color: "bg-secondary-500",
      title: "Automotive Rubber Parts",
      subtitle: "Automotive Rubber Parts",
      desc: "Based on IATF 16949 certification, we supply rubber parts that meet the highest quality standards required by the automotive industry. As a Tier 1 supplier to Hyundai Motor and Kia, we operate a rigorous quality management system.",
      features: [
        "IATF 16949 certified quality system",
        "PPAP, APQP and other automotive standard processes",
      ],
      applications: ["Dampers", "Hoses/Tubes", "Weather strips"],
      image: "https://readdy.ai/api/search-image?query=Automotive%20rubber%20bushings%20and%20engine%20mounts%20displayed%20on%20clean%20industrial%20workbench%2C%20precision%20automotive%20components%2C%20professional%20industrial%20photography%2C%20soft%20studio%20lighting%2C%20black%20rubber%20parts%20with%20metal%20inserts%2C%20engineering%20quality%20control%20aesthetic&width=1200&height=800&seq=krubber-business-automotive&orientation=landscape",
    },
    {
      id: "electronics",
      icon: "ri-cpu-line",
      color: "bg-accent-500",
      title: "Electronics Rubber Parts",
      subtitle: "Electronics Rubber Parts",
      desc: "We manufacture precision rubber parts for waterproofing, dustproofing, insulation, and sealing of electrical and electronic devices. Centered on silicone rubber, we supply highly reliable parts that satisfy both electrical properties and heat resistance.",
      features: [
        "Insulating and conductive silicone rubber",
        "IP67 and IP68 waterproof design",
        "Ultra-precision molding (±0.05mm tolerance)",
        "RoHS, REACH and other environmental compliance",
      ],
      applications: ["Waterproof seals/gaskets", "Keypads/buttons", "Insulation parts", "Thermal pads"],
      image: "https://readdy.ai/api/search-image?query=Silicone%20rubber%20electronic%20components%20and%20seals%20on%20clean%20white%20workstation%2C%20precision%20electronic%20rubber%20parts%2C%20waterproof%20gaskets%20and%20keypads%2C%20professional%20industrial%20photography%2C%20clean%20bright%20studio%20lighting%2C%20high-tech%20manufacturing%20aesthetic&width=1200&height=800&seq=krubber-business-electronics&orientation=landscape",
    },
    {
      id: "custom",
      icon: "ri-pencil-ruler-2-line",
      color: "bg-primary-500",
      title: "Custom Rubber Product Development",
      subtitle: "Custom Development",
      desc: "Product development is possible with just a drawing or an idea. We provide a one-stop custom development service covering material selection, mold design, prototyping, and mass production verification.",
      features: [
        "Drawing review and material recommendation consulting",
        "3D modeling and mold design collaboration",
        "Prototype production (within 2 weeks)",
        "Mass production transition and post-sale technical support",
      ],
      applications: ["New developments", "Localization replacements", "Performance improvements", "Reverse-engineered products"],
      image: "https://public.readdy.ai/ai/img_res/edited_742b5db300eb71115bde66dce4f391ec_24dd1d57.jpg",
    },
    {
      id: "process",
      icon: "ri-flow-chart",
      color: "bg-secondary-500",
      title: "Product Development Process",
      subtitle: "Development Process",
      desc: "Our systematic product development process is carried out through close collaboration with customers. Each stage is verified to ensure optimal quality and delivery.",
      features: [
        "Stage 1: Requirements analysis and material selection",
        "Stage 2: Mold design and fabrication",
        "Stage 3: Prototype molding and dimensional verification",
        "Stage 4: Material testing and customer approval",
        "Stage 5: Mass production and quality control",
      ],
      applications: ["Average development period: 4-8 weeks", "Urgent cases: 2 weeks", "Mass production lead time: 2-4 weeks"],
      image: "https://readdy.ai/api/search-image?query=Modern%20industrial%20product%20development%20process%20flowchart%20visualization%20on%20clean%20workspace%20with%20rubber%20product%20samples%2C%20engineering%20planning%20and%20quality%20control%20concept%2C%20professional%20industrial%20photography%2C%20soft%20natural%20lighting%2C%20organized%20systematic%20approach%20aesthetic&width=1200&height=800&seq=krubber-business-process&orientation=landscape",
    },
  ],
  inquiry: "Inquire About This",
  page: {
    title: "Business",
    subtitle: "A comprehensive rubber product solution built on compression molding technology",
  },
};